import type { AvatarLayerSelection } from '../types/user';

export const AVATAR_GENERATOR_ASSET_ROOT = '/assets/avatar-generator';
const SPRITE_SHEET_SIZE = 32;

export interface AvatarLayerSourceMap {
  body: string;
  eyes: string;
  hairstyle: string;
  outfit: string;
  accessory: string | null;
  prop: string | null;
}

const bodySource = (file: string): string => `${AVATAR_GENERATOR_ASSET_ROOT}/Bodies/${SPRITE_SHEET_SIZE}x${SPRITE_SHEET_SIZE}/${file}`;
const eyesSource = (file: string): string => `${AVATAR_GENERATOR_ASSET_ROOT}/Eyes/${SPRITE_SHEET_SIZE}x${SPRITE_SHEET_SIZE}/${file}`;
const hairstyleSource = (file: string): string =>
  `${AVATAR_GENERATOR_ASSET_ROOT}/Hairstyles/${SPRITE_SHEET_SIZE}x${SPRITE_SHEET_SIZE}/${file}`;
const outfitSource = (file: string): string => `${AVATAR_GENERATOR_ASSET_ROOT}/Outfits/${SPRITE_SHEET_SIZE}x${SPRITE_SHEET_SIZE}/${file}`;
const accessorySource = (file: string): string =>
  `${AVATAR_GENERATOR_ASSET_ROOT}/Accessories/${SPRITE_SHEET_SIZE}x${SPRITE_SHEET_SIZE}/${file}`;

const propSource = (value: string): string | null => {
  const [folder, file] = value.split('/');
  if (!folder || !file) {
    return null;
  }
  return `${AVATAR_GENERATOR_ASSET_ROOT}/${folder}/${SPRITE_SHEET_SIZE}x${SPRITE_SHEET_SIZE}/${file}`;
};

export const avatarLayerSourceMap = (selection: AvatarLayerSelection): AvatarLayerSourceMap => ({
  body: bodySource(selection.body),
  eyes: eyesSource(selection.eyes),
  hairstyle: hairstyleSource(selection.hairstyle),
  outfit: outfitSource(selection.outfit),
  accessory: selection.accessory ? accessorySource(selection.accessory) : null,
  prop: selection.prop ? propSource(selection.prop) : null,
});

export const avatarLayerSourceList = (selection: AvatarLayerSelection): string[] => {
  const sources = avatarLayerSourceMap(selection);
  return [sources.body, sources.eyes, sources.outfit, sources.hairstyle, sources.accessory, sources.prop].filter(
    (source): source is string => Boolean(source),
  );
};

export const avatarPreviewAnchorSource = (selection: AvatarLayerSelection): string => {
  const sources = avatarLayerSourceMap(selection);
  return sources.prop ?? sources.accessory ?? sources.outfit ?? sources.body;
};
